import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI } from "../../shared";
import { Formulario } from "../../shared";
import { Toast } from "primereact/toast";

export default function NuevoProceso() {
  const [loaderEnvio, setLoaderEnvio] = useState(false);

  const toast = useRef(null);

  const navigate = useNavigate();

  const crearProcesoFormConfig = {
    secciones: [
      {
        nombre: "Datos del proceso",
        campos: [
          {
            nombre: "nombrefantasia",
            tipoitemformularioid: 1,
            etiqueta: "Nombre del proceso",
            requerido: true,
          },
          {
            nombre: "clienteid",
            tipoitemformularioid: 5,
            etiqueta: "Cliente",
            requerido: true,
            opciones: "admin/cliente",
            sinOpcionInicial: true,
          },
          {
            nombre: "certificadotipoid",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de certificado",
            requerido: true,
            opciones: "admin/config/certificadotipo?disponibleproceso=true",
            sinOpcionInicial: true,
          },
          {
            nombre: "esquemaid",
            tipoitemformularioid: 5,
            etiqueta: "Esquema de certificación",
            requerido: true,
            opciones: "admin/config/esquema",
            sinOpcionInicial: true,
            queryparams: ["certificadotipoid"],
          },
          {
            nombre: "normaid",
            tipoitemformularioid: 5,
            etiqueta: "Norma",
            requerido: true,
            opciones: "admin/norma",
            sinOpcionInicial: true,
            queryparams: ["certificadotipoid"],
          },
          {
            nombre: "sitioFabricaId",
            tipoitemformularioid: 5,
            etiqueta: "Sitio fábrica",
            opciones: "admin/proceso/fabricas",
            sinOpcionInicial: true,
            queryparams: ["clienteid"],
          },
          {
            nombre: "sitioFabricanteId",
            tipoitemformularioid: 5,
            etiqueta: "Sitio fabricante",
            opciones: "admin/proceso/fabricantes",
            sinOpcionInicial: true,
            queryparams: ["clienteid"],
          },
        ],
      },
    ],
    botones: [
      {
        etiqueta: "Crear proceso",
        callback: crearProcesoSubmit,
        validar: true,
      },
    ],
  };

  function crearProcesoSubmit(camposFormulario) {
    setLoaderEnvio(true);
    accessAPI(
      "POST",
      "admin/proceso",
      camposFormulario,
      (respuesta) => {
        navigate(`/proceso/${respuesta.id}`);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0].msg,
          sticky: true
        });
        setLoaderEnvio(false);
      }
    );
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <div className="tarjetasContainer">
        <div className="tarjeta tresCuartos">
          <Formulario config={crearProcesoFormConfig} loader={loaderEnvio} />
        </div>
      </div>
    </>
  );
}
